<div class="premium-loading-overlay" *ngIf="displayLoader">
  <!-- Versión simplificada pero premium -->
  <div class="simple-premium-loader">
    <div class="loader-logo" [ngClass]="size">
      <div class="shimmer-light"></div>
    </div>
    <div class="loader-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>